'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _translate = require('../../language/translate');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Renders a box displaying the current application quote estimate,
 * as well as any possible details regarding this estimate.
 * @extends {Component}
 */
var ExpatQuoteComponent = function (_React$Component) {
  _inherits(ExpatQuoteComponent, _React$Component);

  function ExpatQuoteComponent() {
    _classCallCheck(this, ExpatQuoteComponent);

    return _possibleConstructorReturn(this, (ExpatQuoteComponent.__proto__ || Object.getPrototypeOf(ExpatQuoteComponent)).apply(this, arguments));
  }

  _createClass(ExpatQuoteComponent, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        _reactBootstrap.Alert,
        { className: 'ingle-form-quote quote-box' },
        _react2.default.createElement(
          'table',
          null,
          _react2.default.createElement(
            'tbody',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                null,
                _react2.default.createElement(
                  'h2',
                  { className: 'display-price quote-price-display' },
                  (0, _translate.t)('Your Quote'),
                  ': ',
                  this.props.quoteAmount ? this.props.quoteAmount : this.props.initialQuoteAmount + ' ' + this.props.quoteCurrency
                )
              )
            ),
            function () {
              if (_this2.props.quoteDetails) {
                return _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    null,
                    _this2.props.quoteDetails
                  )
                );
              }

              return null;
            }()
          )
        )
      );
    }
  }]);

  return ExpatQuoteComponent;
}(_react2.default.Component);

ExpatQuoteComponent.propTypes = {
  initialQuoteAmount: _react2.default.PropTypes.string,
  quoteAmount: _react2.default.PropTypes.string,
  quoteDetails: _react2.default.PropTypes.string,
  quoteCurrency: _react2.default.PropTypes.string
};
ExpatQuoteComponent.defaultProps = {
  initialQuoteAmount: '$0.00',
  quoteDetails: 'null',
  quoteCurrency: 'CAD'
};
exports.default = ExpatQuoteComponent;


//////////////////
// WEBPACK FOOTER
// ./src/v2/components/common/ExpatQuoteComponent.jsx
// module id = 400
// module chunks = 0